var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-switch-button"},[_c('label',{staticClass:"uk-toggle-switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.modelValue === 1 || _vm.modelValue === true},on:{"change":_vm.toggleValue}}),_c('span',{staticClass:"uk-toggle-slider"})]),_c('p',{staticClass:"toggle-switch-title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }